<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Master of Commerce</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="index.php">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Master of Commerce</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="computer-application ptb--100  horizontal--tab">
  <div class="container">
    <div class="row">
      <div class="col">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="department-tab" data-bs-toggle="tab" data-bs-target="#department"
              type="button" role="tab" aria-controls="department" aria-selected="true">About Department</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="eligibility-tab" data-bs-toggle="tab" data-bs-target="#eligibility"
              type="button" role="tab" aria-controls="eligibility" aria-selected="false">Eligibility Criteria</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="duration-tab" data-bs-toggle="tab" data-bs-target="#duration" type="button"
              role="tab" aria-controls="duration" aria-selected="false">Duration</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="opportunities-tab" data-bs-toggle="tab" data-bs-target="#opportunities"
              type="button" role="tab" aria-controls="opportunities" aria-selected="false">Opportunities which await
              you</button>
          </li>
        </ul>
        <div class="tab-content px-3 py-3" id="myTabContent">
          <div class="tab-pane fade show active" id="department" role="tabpanel" aria-labelledby="department-tab">
            <div>
              <p>M. Com department is committed to equip and train Post Graduate students to
                accept the challenges of business world by providing opportunities for study and analysis of
                advanced commercial and business methods and processes, to develop independent logical
                thinking and facilitate personality development, to equip the students to seek suitable careers in
                management and entrepreneurship, to acquaint students with significance of research in business
                to impart skills regarding methods of data collection and their interpretations, to develop
                communication and analytical skills among students.</p>
            </div>
          </div>
          <div class="tab-pane fade" id="eligibility" role="tabpanel" aria-labelledby="eligibility-tab">
            <p>The student who has passed any Bachelors degree of this University or any other recognized University
              shall be held eligible to be admitted to M.Com. Course.</p>
          </div>
          <div class="tab-pane fade" id="duration" role="tabpanel" aria-labelledby="duration-tab">
            <p>The M.Com (Semester pattern with Credit System) degree Programme shall be of 2years duration divided into
              two parts, Part I and Part II, and 4 semesters.</p>

          </div>
          <div class="tab-pane fade" id="opportunities" role="tabpanel" aria-labelledby="opportunities-tab">
            <p>After completing an M.Com (Master of Commerce) degree, you have a variety of career opportunities
              available to you. M.Com graduates are sought after in various sectors due to their strong foundation in
              commerce, finance, and business. Work in public accounting firms, corporations, or government agencies to
              prepare and maintain financial records. Earn a professional certification such as a Certified Management
              Accountant (CMA) to specialize in cost management, budgeting, and financial analysis. Assist companies in
              raising capital, mergers and acquisitions, and financial advisory services. Oversee the planning and
              management of the supply chain, including procurement, logistics, and inventory management etc.</p>

          </div>
        </div>
        <div class="text-center">
          <a href="https://raisoni.nopaperforms.com/rgi" target="_blank" class="cmn-button">Apply Now</a>
        </div>
      </div>
    </div>
  </div>
</section>
